import React, {useCallback, useEffect, useState} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import PaginationWidget from "../UI/PaginationWidget/PaginationWidget";
import axios from "axios";

/**
 *
 * @param children child must accept a filter prop and an updateFilter prop
 * @param title optional, lets you set a title
 * @param endpoint the endpoint you want to call
 * @param onFilterChange a function called when the filter is changed, receives data from endpoint call
 * @param dataMapFunction
 * @param onSelectItem sends info about item selected
 * @param filterByUserId
 * @returns {Element} an object that handles searching on its own and lets you access results via a ref function.
 * @constructor
 */
export default function SimpleSearchWrapper({ children, title, endpoint, onFilterChange, dataMapFunction, onSelectItem, filterByUserId }) {
    const [searchFilter, setSearchFilter] = useState('');
    const [searchResults, setSearchResults] = useState([])
    const [offset, setOffset] = useState(0)
    const [count, setCount] = useState(0)
    const [data, setData] = useState({patterns_array: [], count: 0})


    let userFilter = ''
    if (filterByUserId && Number.isInteger(+filterByUserId)) {
        userFilter = '&author_ids_array[]=' + filterByUserId
    }

    // Function to update the filter
    const updateFilter = useCallback((newFilter) => {
        if (newFilter !== searchFilter) {
            setOffset(0)
        }
        setSearchFilter(newFilter);
        // make api call
        axios.get(endpoint + newFilter + '&quantity=9&offset=' + offset + userFilter)
            .then((response) => {
                onFilterChange && onFilterChange(searchFilter)
                setData(response.data)
            })
        onFilterChange && onFilterChange(searchFilter)
    }, [endpoint, offset, onFilterChange, searchFilter, userFilter]);

    useEffect(() => {
        updateFilter(searchFilter)
    }, [offset, searchFilter, updateFilter]);

    useEffect(() => {
        const dataObj = dataMapFunction(data);
        setSearchResults(() => dataObj.arr)
        setCount(dataObj.count)
    }, [data, dataMapFunction])

    // Pass props to children
    const childrenWithProps = React.Children.map(children, (child) =>
        React.cloneElement(child, {
            currentSearchFilter: searchFilter,
            updateCurrentFilter: updateFilter,
        })
    );



    return (
        <section>
            <div className="d-flex pattern-list-wrapper">
                <div className="pattern-list">
                    <Container fluid className={' mx-auto text-center pattern-list-container'}
                               style={{paddingBlock: 20}}>
                        {title && title}
                        {childrenWithProps}
                    </Container>
                </div>
            </div>
            <div className="d-flex pattern-list-wrapper">
                <div className="pattern-list">
                    <Container fluid className="pattern-list-container">
                        {/*<Row md={3} lg={3}>*/}
                        <Row md={1} lg={3} xl={3}>
                            {searchResults.map((i, index) => <Col sm={12} className="pattern-list-col"
                                                                  key={'searchlist-' + index}>{i}</Col>)}
                        </Row>
                        <Row className="pattern-list-pagination">
                            <PaginationWidget
                                className="col-sm-6 align-self-center"
                                updatePage={setOffset}
                                count={count}
                                quantity={9}
                                offset={offset}
                            />
                        </Row>
                    </Container>
                </div>
            </div>
        </section>
);
}
